import {
  createAgentDefinition as publicCreateAgentDefinition,
  getAgentDefinition as publicGetAgentDefinition,
  updateAgentDefinition as publicUpdateAgentDefinition,
  deleteAgentDefinition as publicDeleteAgentDefinition,
  queryAgentDefinitions as publicQueryAgentDefinitions,
  typedQueryAgentDefinitions as publicTypedQueryAgentDefinitions,
  bulkUpdateAgentDefinitionTags as publicBulkUpdateAgentDefinitionTags,
  bulkUpdateAgentDefinitionTagsByFilter as publicBulkUpdateAgentDefinitionTagsByFilter,
} from './agents-v1-agent-definition-agent-registry.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  AgentDefinitionQuery,
  AgentDefinitionsQueryBuilder,
  typedQueryAgentDefinitions as universalTypedQueryAgentDefinitions,
} from './agents-v1-agent-definition-agent-registry.universal.js';

function customQueryAgentDefinitions(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryAgentDefinitions(httpClient)(),
    typedQueryFunction: (query: AgentDefinitionQuery) =>
      publicTypedQueryAgentDefinitions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): AgentDefinitionsQueryBuilder;
  function overloadedQuery(
    query: AgentDefinitionQuery
  ): ReturnType<typeof universalTypedQueryAgentDefinitions>;
  function overloadedQuery(query?: AgentDefinitionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

/** @internal */
export const createAgentDefinition: MaybeContext<
  BuildRESTFunction<typeof publicCreateAgentDefinition> &
    typeof publicCreateAgentDefinition
> = /*#__PURE__*/ createRESTModule(publicCreateAgentDefinition);
/** @internal */
export const getAgentDefinition: MaybeContext<
  BuildRESTFunction<typeof publicGetAgentDefinition> &
    typeof publicGetAgentDefinition
> = /*#__PURE__*/ createRESTModule(publicGetAgentDefinition);
/** @internal */
export const updateAgentDefinition: MaybeContext<
  BuildRESTFunction<typeof publicUpdateAgentDefinition> &
    typeof publicUpdateAgentDefinition
> = /*#__PURE__*/ createRESTModule(publicUpdateAgentDefinition);
/** @internal */
export const deleteAgentDefinition: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAgentDefinition> &
    typeof publicDeleteAgentDefinition
> = /*#__PURE__*/ createRESTModule(publicDeleteAgentDefinition);
/** @internal */
export const bulkUpdateAgentDefinitionTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateAgentDefinitionTags> &
    typeof publicBulkUpdateAgentDefinitionTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateAgentDefinitionTags);
/** @internal */
export const bulkUpdateAgentDefinitionTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateAgentDefinitionTagsByFilter> &
    typeof publicBulkUpdateAgentDefinitionTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateAgentDefinitionTagsByFilter);
export const queryAgentDefinitions: MaybeContext<
  BuildRESTFunction<typeof customQueryAgentDefinitions> &
    typeof customQueryAgentDefinitions
> = /*#__PURE__*/ createRESTModule(customQueryAgentDefinitions);

export {
  AgentStatus,
  SortOrder,
  WebhookIdentityType,
} from './agents-v1-agent-definition-agent-registry.universal.js';
export {
  AgentDefinition,
  ExtendedFields,
  Tags,
  TagList,
  AgentDefinitionTagsModified,
  CreateAgentDefinitionRequest,
  CreateAgentDefinitionResponse,
  GetAgentDefinitionRequest,
  GetAgentDefinitionResponse,
  UpdateAgentDefinitionRequest,
  UpdateAgentDefinitionResponse,
  DeleteAgentDefinitionRequest,
  DeleteAgentDefinitionResponse,
  QueryAgentDefinitionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryAgentDefinitionsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkUpdateAgentDefinitionTagsRequest,
  BulkUpdateAgentDefinitionTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateAgentDefinitionTagsResult,
  BulkActionMetadata,
  BulkUpdateAgentDefinitionTagsByFilterRequest,
  BulkUpdateAgentDefinitionTagsByFilterResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  UpdateAgentDefinition,
  AgentDefinitionsQueryResult,
  AgentDefinitionsQueryBuilder,
  AgentDefinitionQuerySpec,
  BulkUpdateAgentDefinitionTagsOptions,
  BulkUpdateAgentDefinitionTagsByFilterOptions,
} from './agents-v1-agent-definition-agent-registry.universal.js';
export { utils } from './agents-v1-agent-definition-agent-registry.universal.js';
export {
  AgentStatusWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateAgentDefinitionTagsApplicationErrors,
  BulkUpdateAgentDefinitionTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  AgentDefinitionQuery,
} from './agents-v1-agent-definition-agent-registry.universal.js';
